<template>
  <div>
    <div class="msg-tab">
      <div style="cursor: pointer"
           :class="['all', { activeFont: activeFont == false }]"
           @click="switchTab(false)">
        未读消息({{ unreadCount }})
      </div>
      <div style="cursor: pointer"
           :class="['all', { activeFont: activeFont == true }]"
           @click="switchTab(true)">
        已读消息({{ readCount }})
      </div>
    </div>
    <div class="msg-list-box">
      <div v-if="noteList && noteList.length > 0">
        <div class="msg-list"
             @click="see(item)"
             v-for="(item, i) in noteList"
             :key="i">
          <div class="list-left">
            <div class="list-time">
              {{ item.createDate && item.createDate.slice(0, 10) }}
            </div>
            <!-- <div class="list-time">{{ "2023-12-27" }}</div> -->
            <div class="list-title">{{ item.title }}</div>
          </div>
          <!-- <div class="list-right">{{ activeFont ? "已读" : "未读" }}</div> -->
        </div>
      </div>
      <el-empty v-else
                description="暂无数据"></el-empty>
    </div>
    <el-dialog :title="messageTitle"
               :visible.sync="dialogVisible"
               width="800px"
               append-to-body>
      <div style="max-height: 500px">{{ messageContent }}</div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {},
  data () {
    return {
      noteList: [],
      readCount: 0,
      unreadCount: 0,
      activeFont: false,
      dialogVisible: false,
      messageContent: "",
      messageTitle: "",
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {},
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {
    this.MessagePage(false);
  },
  // 方法集合
  methods: {
    readMessage (id) {
      let formData = new FormData();
      formData.append("id", id);
      this.$api.manage.MessageRead(formData).then((res) => {
        if (res.code === 0) {
          if (!this.activeFont) {
            this.MessagePage(false);
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    switchTab (flag) {
      this.activeFont = flag;
      this.MessagePage(flag);
    },
    MessagePage (flag) {
      let sendData = {
        pageIndex: 1,
        pageSize: 999999,
        isRead: flag,
        messageCompanyId: "80dc0859-45a9-4201-94bb-044f457fcf6c"
      };

      this.$api.manage.MessagePage(sendData).then((res) => {
        if (res.code === 0) {
          this.readCount = res.data.readCount;
          this.unreadCount = res.data.notReadCount;

          this.noteList = res.data.pageData.data;
        }
      });
    },
    see (v) {
      this.dialogVisible = true;
      this.messageContent = v.messageContent;
      this.messageTitle = v.title;
      if (this.activeFont == false) {
        this.readMessage(v.id);
      }
    },
  },
};
</script>
<style lang='less' scoped>
.msg-tab {
  display: flex;

  justify-content: center;
  .all {
    width: 127px;
    height: 28px;
    background-color: #e6e6e6;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    line-height: 28px;
  }
}
.activeFont {
  background-color: #4e89f7 !important;
  color: #fff;
}
.msg-list-box {
  border-top: 1px solid #4e89f7;
  height: 233px;
  overflow: auto;

  .msg-list {
    width: 100%;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dee7ff;
    cursor: pointer;
    .list-left {
      display: flex;
      .list-title {
        width: 440px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .list-time {
        font-size: 12px;
        margin-right: 57px;
      }
    }
    .list-right {
    }
  }
}
</style>